import React, { useEffect, useState } from 'react';

type RadioOption = {
    label: string;
    value: string;
    icon: string; // Ensure the icon type matches (string if it's a URL or path)
    count?: number;
};

interface RadioGroupCustomProps {
    options: RadioOption[];
    name: string;
    onChange: (value: string | number) => void;
    selectedValue?: string;
    disabled?: boolean;
}

export default function RadioGroupCustom({ options, name, onChange, selectedValue, disabled }: RadioGroupCustomProps) {
    const [selected, setSelected] = useState<string | number>(selectedValue || '');

    useEffect(() => {
        if (selectedValue) {
            setSelected(selectedValue);
        }
    }, [selectedValue]);

    const handleSelect = (value: string) => {
        if (!disabled) {
            setSelected(value);
            onChange(value);
        }
    };

    return (
        <div className='flex rounded-basicRadius border border-feildBorder p-1'>
            {options.map((option: any, index) => (
                <div
                    key={index}
                    className={`${selected === option.value ? "checked" : ""
                        } button block py-2 px-2 justify-center rounded-basicRadius w-full ${!disabled ? 'hover:cursor-pointer' : 'cursor-pointer'
                        }`}
                    onClick={() => handleSelect(option.value)}
                >
                    <input
                        type="radio"
                        id={option.value}
                        name={name}
                        value={option.value}
                        checked={selected === option.value}
                        onChange={() => handleSelect(option.value)} // Ensure state sync
                        className="btn-group-input hidden "
                        disabled={disabled}
                    />
                    <label
                        key={option.value}
                        htmlFor={option.value}
                        className="btn-group-label font-aeonikReg text-darkergrey text-sm text-center cursor-pointer"
                    >
                        <div className="flex justify-center items-center cursor-pointer">
                            <img src={option.icon} className="mr-2" alt={option.label} />
                            {option.label}{option?.count ? ` (${option.count})` : ''}
                        </div>
                    </label>
                </div>
            ))}
        </div>
    );
}